// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vwTK","label":"styles_label__pezk7"};